import { useCallback, useRef, useState } from "react";

export function useToast(duration = 2200) {
  const [message, setMessage] = useState<string | null>(null);
  const timerRef = useRef<number | null>(null);

  const show = useCallback(
    (msg: string) => {
      setMessage(msg);
      if (timerRef.current) {
        window.clearTimeout(timerRef.current);
      }
      timerRef.current = window.setTimeout(() => setMessage(null), duration);
    },
    [duration],
  );

  return { message, show };
}